import {
    FETCH_MISSING_APP_SUCCESS,
    FETCH_MISSING_APP_REQUEST,
    FETCH_MISSING_APP_FAILURE,
    UPDATE_MISSING_APP_REQUEST,
    UPDATE_MISSING_APP_SUCCESS,
    UPDATE_MISSING_APP_FAILURE,
    SEARCH_MISSING_APP_REQUEST,
    SEARCH_MISSING_APP_SUCCESS,
    SEARCH_MISSING_APP_FAILURE,
    ADD_MISSING_APP,
    UPDATE_LOCAL_MISSING_APP,
    FETCH_RESOLVE_AND_UNRESOLVE_SUCCESS,
    FETCH_RESOLVE_AND_UNRESOLVE_REQUEST,
    FETCH_RESOLVE_AND_UNRESOLVE_FAILURE
} from './missingAppAction';

const initialState = {
    loading: false,
    missingAppData: [],
    searchResults: [],
    resolveUnrResolve: [],
    error: '',
};

const missingAppReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MISSING_APP_REQUEST:
        case UPDATE_MISSING_APP_REQUEST:
            return {
                ...state,
                loading: false,
            };
        case FETCH_MISSING_APP_SUCCESS:
            return {
                ...state,
                loading: false,
                missingAppData: [...state.missingAppData, ...action.payload],
                error: '',
            };
        case ADD_MISSING_APP:
            return {
                ...state,
                missingAppData: [action.payload, ...state.missingAppData],
            };
        case UPDATE_LOCAL_MISSING_APP:
            return {
                ...state,
                missingAppData: state.missingAppData.map((app) =>
                    app.appId === action.payload.appId
                        ? { ...app, ...action.payload }
                        : app
                ),
            };
        case UPDATE_MISSING_APP_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case FETCH_MISSING_APP_FAILURE:
        case UPDATE_MISSING_APP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case SEARCH_MISSING_APP_REQUEST:
            return {
                ...state,
                loading: false,
            };
        case SEARCH_MISSING_APP_SUCCESS:
            return {
                ...state,
                loading: false,
                searchResults: action.payload,
                error: '',
            };
        case SEARCH_MISSING_APP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case FETCH_RESOLVE_AND_UNRESOLVE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_RESOLVE_AND_UNRESOLVE_SUCCESS:
            return {
                ...state,
                loading: false,
                resolveUnrResolve: action.payload,
            };
        case FETCH_RESOLVE_AND_UNRESOLVE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default missingAppReducer;
